export class PricingConfigurationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getConfiguration() {
    return this.#http.get('/api/pricing-configuration');
  }

  async editConfiguration(body) {
    return this.#http.put('/api/pricing-configuration', body);
  }

  async createConfiguration(body) {
    return this.#http.post('/api/pricing-configuration', body);
  }
}
